import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home         from "./pages/Home";
import Login        from "./pages/Login";
import Register     from "./pages/Register";
import VerifyAccount from "./pages/VerifyAccount";
import ForgetPassword from "./pages/ForgetPassword";
import Dashboard    from "./pages/Dashboard";
import Horaires     from "./pages/Horaires";
import Tarifs       from "./pages/Tarifs";
import Vehicules    from "./pages/Vehicules";
import Marchandises from "./pages/Marchandises";
import Contact      from "./pages/Contact";
import AdminPage       from "./pages/AdminPage";
import AgentPage       from "./pages/AgentPage";
import ProgrammerPage  from "./pages/ProgrammerPage";
import AdminUsers       from "./pages/AdminUsers";
import AdminBookings    from "./pages/AdminBookings";
import AdminRevenue     from "./pages/AdminRevenue";
import AdminSettings    from "./pages/AdminSettings";
import AdminNews        from "./pages/AdminNews";
import AdminSchedules   from "./pages/AdminSchedules";
import ControllerScan   from "./pages/ControllerScan";
import AdminMessages    from "./pages/AdminMessages";
import PrivacyPolicy    from "./pages/PrivacyPolicy";
import TermsOfService   from "./pages/TermsOfService";

import { AuthProvider }  from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import { NotifyProvider } from "./components/Notify";
import AnnouncementBar   from "./components/AnnouncementBar";
import ProtectedRoute    from "./components/ProtectedRoute";
import RoleProtectedRoute from "./components/RoleProtectedRoute";
import PublicRoute       from "./components/PublicRoute";

const ADMIN_ROLES = ["ROLE_ADMIN", "ROLE_AGENT", "ROLE_PROGRAMMER", "ROLE_CONTROLLER", "ROLE_SUPPORT"];

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
      <NotifyProvider>
      <Router>
        <AnnouncementBar />
        <Routes>

          {/* ── PUBLIC ── */}
          <Route path="/" element={<PublicRoute><Home /></PublicRoute>} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/verify-account" element={<VerifyAccount />} />
          <Route path="/forgot" element={<PublicRoute><ForgetPassword /></PublicRoute>} />
          <Route path="/horaires" element={<PublicRoute><Horaires /></PublicRoute>} />
          <Route path="/tarifs"   element={<PublicRoute><Tarifs /></PublicRoute>} />
          <Route path="/vehicules"    element={<PublicRoute><Vehicules /></PublicRoute>} />
          <Route path="/marchandises" element={<PublicRoute><Marchandises /></PublicRoute>} />
          <Route path="/contact"  element={<PublicRoute><Contact /></PublicRoute>} />
          <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
          <Route path="/conditions-utilisation"        element={<TermsOfService />} />
          <Route path="/confidentialite"               element={<PrivacyPolicy />} />
          <Route path="/conditions"                    element={<TermsOfService />} />

          {/* ── VOYAGEUR ── */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

          {/* ── ADMIN SETRAG (accès réservé aux rôles staff) ── */}
          <Route path="/admin"                element={<RoleProtectedRoute allowedRoles={["ROLE_ADMIN"]}><AdminPage /></RoleProtectedRoute>} />
          <Route path="/agent"                element={<RoleProtectedRoute allowedRoles={["ROLE_AGENT"]}><AgentPage /></RoleProtectedRoute>} />
          <Route path="/programmer"           element={<RoleProtectedRoute allowedRoles={["ROLE_PROGRAMMER"]}><ProgrammerPage /></RoleProtectedRoute>} />
          <Route path="/admin/users"          element={<RoleProtectedRoute allowedRoles={ADMIN_ROLES}><AdminUsers /></RoleProtectedRoute>} />
          <Route path="/admin/bookings"       element={<RoleProtectedRoute allowedRoles={ADMIN_ROLES}><AdminBookings /></RoleProtectedRoute>} />
          <Route path="/admin/revenue"        element={<RoleProtectedRoute allowedRoles={["ROLE_ADMIN"]}><AdminRevenue /></RoleProtectedRoute>} />
          <Route path="/admin/settings"       element={<RoleProtectedRoute allowedRoles={["ROLE_ADMIN"]}><AdminSettings /></RoleProtectedRoute>} />
          <Route path="/admin/news"           element={<RoleProtectedRoute allowedRoles={["ROLE_ADMIN"]}><AdminNews /></RoleProtectedRoute>} />
          <Route path="/admin/schedules"      element={<RoleProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_PROGRAMMER"]}><AdminSchedules /></RoleProtectedRoute>} />
          <Route path="/admin/scan"           element={<RoleProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_AGENT", "ROLE_CONTROLLER", "ROLE_PROGRAMMER"]}><ControllerScan /></RoleProtectedRoute>} />
          <Route path="/admin/messages"       element={<RoleProtectedRoute allowedRoles={["ROLE_ADMIN", "ROLE_SUPPORT", "ROLE_AGENT", "ROLE_CONTROLLER", "ROLE_PROGRAMMER"]}><AdminMessages /></RoleProtectedRoute>} />

        </Routes>
      </Router>
      </NotifyProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
